import { jsx as _jsx } from "react/jsx-runtime";
export default function OneCol(_ref) {
  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'col100' : _ref$className;
  return /*#__PURE__*/_jsx("div", {
    className: "grid",
    children: /*#__PURE__*/_jsx("div", {
      className: "row",
      children: /*#__PURE__*/_jsx("div", {
        className: className,
        children: children
      })
    })
  });
}